module.exports = __webpack_public_path__ + "static/media/budget-period-cs-blue.7c2b7cb6.svg";